/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useEffect, useState } from 'react';
import { useVideoContext } from '../../../../contexts/videoProvider/videoContext';
import { useParticipantsChange } from '@components/videoProvider/zoom/hooks/useParticipantsChange';
import { partition } from '@utils/lodash';

export const usePinnedParticipants = () => {
  const { videoProvider } = useVideoContext();
  const [pageParticipants, setPageParticipants] = useState<VideoProvider.IParticipant[]>(
    videoProvider.getParticipants(),
  );
  const [pinnedParticipants, setPinnedParticipants] = useState<VideoProvider.IParticipant[]>([]);
  const [nonPinnedParticipants, setNonPinnedParticipants] = useState<VideoProvider.IParticipant[]>([]);

  useParticipantsChange(videoProvider, (participants: VideoProvider.IParticipant[]) => {
    setPageParticipants(participants);
  });

  useEffect(() => {
    const currentUserId = videoProvider.getCurrentUserId();
    const [currentUser, otherUsers] = partition(pageParticipants, user => user.userId === currentUserId);
    const [notaryUser, nonPinnedParticipants] = partition(otherUsers, user => user.isHost);

    const pinnedParticipants = [...currentUser, ...notaryUser];

    setPinnedParticipants(pinnedParticipants);
    setNonPinnedParticipants(nonPinnedParticipants);
  }, [pageParticipants]);

  return { pinnedParticipants, nonPinnedParticipants };
};
